// src/pages/admin/GameJamCreatePage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc as firestoreDoc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase';

const awardLabels = ['대상', '최우수상', '우수상', '우수상'];

export default function GameJamCreatePage() {
  const navigate = useNavigate();
  const [year, setYear] = useState('');
  const [ids, setIds] = useState(['', '', '', '']);
  const [loading, setLoading] = useState(false);

  // Load existing only when year is exactly 4 digits
  useEffect(() => {
    if (!/^\d{4}$/.test(year)) return;
    (async () => {
      const snap = await getDoc(firestoreDoc(db, 'data', 'gamejam'));
      if (!snap.exists()) return;
      const data = snap.data();
      const key = `gamejam${year}`;
      if (Array.isArray(data[key])) {
        const arr = data[key].slice(0, 4);
        while (arr.length < 4) arr.push('');
        setIds(arr);
      }
    })();
  }, [year]);

  const handleChangeId = (idx, value) => {
    setIds(prev => {
      const next = [...prev];
      next[idx] = value;
      return next;
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!/^\d{4}$/.test(year)) {
      alert('연도를 네 자리 숫자로 입력해주세요.');
      return;
    }
    setLoading(true);
    const key = `gamejam${year}`;
    const arr = ids.slice(0, 4);
    while (arr.length < 4) arr.push('');
    await updateDoc(firestoreDoc(db, 'data', 'gamejam'), {
      [key]: arr
    });
    setLoading(false);
    navigate('/admin', { state: { tab: 'gamejams' } });
  };

  return (
    <div className="max-w-xl min-h-screen mx-auto space-y-12 py-20">
      <h1 className="text-2xl font-bold">새로운 게임잼 등록</h1>
      <form onSubmit={handleSubmit} className="space-y-4 bg-neutral-800 p-6 rounded-lg shadow">
        <div>
          <label className="block mb-1 text-gray-300">연도</label>
          <input
            type="text"
            maxLength={4}
            value={year}
            onChange={e => setYear(e.target.value.replace(/\D/g, ''))}
            placeholder="예: 2025"
            className="w-full bg-neutral-700 text-white border border-neutral-600 rounded p-2"
            required
          />
        </div>

        {awardLabels.map((label, idx) => (
          <div key={idx}>
            <label className="block mb-1 text-gray-300">{label} 게임 ID</label>
            <input
              type="text"
              value={ids[idx]}
              onChange={e => handleChangeId(idx, e.target.value)}
              placeholder={`게임 ID (${label})`}
              className="w-full bg-neutral-700 text-white border border-neutral-600 rounded p-2"
            />
          </div>
        ))}

        <div className="flex justify-end">
          <button
            type="button"
            onClick={() => navigate('/admin', { state: { tab: 'gamejams' } })}
            className="px-4 py-2 mr-2 border border-gray-500 text-gray-500 rounded hover:bg-gray-700"
            disabled={loading}
          >
            취소
          </button>
          <button
            type="submit"
            className={`px-4 py-2 border ${loading ? 'border-gray-500 text-gray-500' : 'border-green-600 text-green-600'} rounded ${loading ? '' : 'hover:bg-green-50'}`}
            disabled={loading}
          >
            {loading ? '저장 중...' : '저장'}
          </button>
        </div>
      </form>
    </div>
  );
}
